export type ModelState = 'TRAINING' | 'TRAINED' | 'ERR'
export type NormalizedModelStatus = 'training' | 'trained' | 'failed' | 'unknown'
export type DeploymentStatus = 'IN_SERVICE' | 'CREATING' | 'ERR' | 'UPDATING' | 'DELETING' | 'READY'
export type DeploymentStatusLower = Lowercase<DeploymentStatus>

export function normalizeModelStatus(state?: ModelState): NormalizedModelStatus {
  if (state === 'TRAINING') return 'training'
  if (state === 'TRAINED') return 'trained'
  if (state === 'ERR') return 'failed'
  return 'unknown'
}

export function getModelStatusVariant(
  status: NormalizedModelStatus
): 'success' | 'warning' | 'danger' | 'secondary' {
  switch (status) {
    case 'training':
      return 'warning'
    case 'trained':
      return 'success'
    case 'failed':
      return 'danger'
    default:
      return 'secondary'
  }
}

export function normalizeDeploymentStatusLower(status?: DeploymentStatus): DeploymentStatusLower {
  const s = status || 'READY'
  return s.toLowerCase() as DeploymentStatusLower
}

export function getDeploymentVariant(
  status: DeploymentStatusLower
): 'success' | 'warning' | 'danger' | 'secondary' {
  switch (status) {
    case 'in_service':
      return 'success'
    case 'creating':
    case 'updating':
      return 'warning'
    case 'err':
      return 'danger'
    case 'deleting':
    case 'ready':
    default:
      return 'secondary'
  }
}

export function getDeploymentStatusText(status?: DeploymentStatus): string {
  switch (status) {
    case 'IN_SERVICE':
      return 'Deployed'
    case 'CREATING':
      return 'Deploying'
    case 'ERR':
      return 'Failed'
    case 'UPDATING':
      return 'Updating'
    case 'DELETING':
      return 'Deleting'
    case 'READY':
    default:
      return 'Ready'
  }
}
